const action = "SIGNAL_DELETE";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const CLEAR = action + '_CLEAR';
export const FAILURE = action + '_FAILURE';

// Surfaced when the BE rejects a delete with HTTP 409 because the
// signal is still published on the marketplace with active
// subscribers. The container subscribes to ``marketplaceConflict``
// to render the cascade-confirm dialog.
export const MARKETPLACE_CONFLICT = action + '_MARKETPLACE_CONFLICT';
export const MARKETPLACE_CONFLICT_CLEAR =
  action + '_MARKETPLACE_CONFLICT_CLEAR';

export const fetchRequest = (payload) => {
    return {
        type: REQUEST,
        payload
    };
};
export const fetchSuccess = (response) => {
    return {
        type: RESPONSE,
        payload: response
    }
};

export const clearState = (response) => ({
    type: CLEAR
});

export const fetchFailure = (error) => ({
    type: FAILURE,
    payload: error
});

export const marketplaceConflict = (payload) => ({
    type: MARKETPLACE_CONFLICT,
    payload,
});

export const clearMarketplaceConflict = () => ({
    type: MARKETPLACE_CONFLICT_CLEAR,
});
